import initAnalytics from 'services/analytics/amplitude';

const loadAmplitude = async (): Promise<void> => {
  await initAnalytics();
};

export default loadAmplitude;
